import React, { useEffect } from 'react';
import { Route, Routes } from "react-router-dom";
import './App.css';
import { AuthProvider } from "./contexts/AuthContext";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { Login } from "./components/pages/Login";
import { Register } from "./components/pages/Register";
import { Home } from "./components/pages/Home";
import { SendData } from "./components/pages/SendData";
import { Anketa } from "./components/pages/Anketa";
import { EmailConfirmation } from "./components/pages/EmailConfirmation";
import { ConfirmEmailPage } from "./components/pages/ConfirmEmailPage";
import { ForgotPassword } from "./components/pages/ForgotPassword";
import { ResetPassword } from "./components/pages/ResetPassword";
import { QRCode } from "./components/pages/QRCode";
import { Feedback } from "./components/pages/Feedback";
import { Documents } from "./components/pages/Documents";
import { About } from "./components/pages/About";
import { setLoggingEnabled } from "./utils/logger";

function App() {
    useEffect(() => {
        fetch('/config.json')
            .then(res => res.json())
            .then(config => {
                setLoggingEnabled(config['logging'] === true);
            })
            .catch(() => {});
    }, []);

    return (
        <AuthProvider>
            <div className="App">
                <Navbar />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/senddata" element={<SendData />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/anketa" element={<Anketa />} />
                    <Route path="/email-confirmation" element={<EmailConfirmation />} />
                    <Route path="/confirm-email" element={<ConfirmEmailPage />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/reset-password" element={<ResetPassword />} />
                    <Route path="/qr-code" element={<QRCode />} />
                    <Route path="/feedback" element={<Feedback />} />
                    <Route path="/documents" element={<Documents />} />
                    <Route path="/about" element={<About />} />
                </Routes>
                <Footer />
            </div>
        </AuthProvider>
    );
}

export default App;